export default "__VITE_ASSET__a40ab793__"